module.exports = "/_next/static/images/Features@2x-f7733700ccce8b1db23d8ad5fc1bc7e7.png";